import React from "react";
import { useSearchParams } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function Policies() {
  const { settings } = useSettings();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "shipping";

  const content = {
    shipping: settings.shipping,
    returns: settings.returns,
    terms: settings.terms,
    privacy: settings.privacy,
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-14 lg:py-20" data-testid="policies-page">
      <h1 className="font-serif text-4xl lg:text-5xl text-obsidian mb-8">Policies</h1>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="flex flex-wrap h-auto gap-1 bg-secondary p-1">
          <TabsTrigger value="shipping" data-testid="tab-shipping">Shipping</TabsTrigger>
          <TabsTrigger value="returns" data-testid="tab-returns">Returns</TabsTrigger>
          <TabsTrigger value="terms" data-testid="tab-terms">Terms</TabsTrigger>
          <TabsTrigger value="privacy" data-testid="tab-privacy">Privacy</TabsTrigger>
        </TabsList>
        {Object.entries(content).map(([k, v]) => (
          <TabsContent key={k} value={k} className="mt-8">
            <p className="text-muted-foreground leading-relaxed whitespace-pre-line">{v}</p>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
